import { ModalContainer } from '../modal'

interface IProps {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  children: React.ReactNode
}

export const OptionsModalContainer: React.FC<IProps> = ({ onDismiss, children }) => {
  return (
    <ModalContainer innerClasses='!min-w-[calc(90%-2rem)] sm:!min-w-0 !w-auto !h-auto' containerClasses='' onDismiss={onDismiss}>
      {children}
    </ModalContainer>
  )
}
